<template lang="pug">
.vgt2024-menu(:class="['top', 'about'].includes(current) ? 'theme-top' : 'theme-default'")
  .vgt2024-menu-logo
    nuxt-link(to="/vgt2024")
      img(src="~/assets/images/vgt/2024/main/logo.png" alt="VIDEOGRAPHERS TOKYO" width="500" height="372")
  ul
    li.is-current(v-if="current === 'top'" v-scroll-to="'#top'")
      a.vgt2024-menu-link
        strong
          IconHomeSvg
          | ホーム
    li(v-else)
      nuxt-link.vgt2024-menu-link(to="/vgt2024")
        strong
          IconHomeSvg
          | ホーム
    li(:class="{ 'is-current': current === 'archives' }")
      nuxt-link.vgt2024-menu-link(to="/vgt2024/archives")
        strong
          IconVideoSvg
          | アーカイブ
    li(:class="{ 'is-current': current === 'timetable' }")
      nuxt-link.vgt2024-menu-link(to="/vgt2024/timetable")
        strong
          IconTimeSvg
          | タイムテーブル
    li(:class="{ 'is-current': current === 'speakers' }")
      nuxt-link.vgt2024-menu-link(to="/vgt2024/speakers")
        strong
          IconUserSvg
          | 登壇者
    li(:class="{ 'is-current': current === 'exhibition' }")
      nuxt-link.vgt2024-menu-link(to="/vgt2024/exhibition")
        strong
          IconExhibitionSvg
          | 展示ブース
    li.pc(:class="{ 'is-current': current === 'visitor' }")
      nuxt-link.vgt2024-menu-link(to="/vgt2024/visitor")
        strong
          IconPlaceSvg
          | 来場者の方へ
  //- 入場券
  .vgt2024-menu-ticket
    //- a(v-if="current === 'top'" v-scroll-to="'#entry'")
      .inner
        strong イベントは終了しました
    nuxt-link.vgt2024-menu-link(v-if="!['top', 'about'].includes(current)" to="/vgt2024/entry")
      .inner
        strong イベントは終了しました

</template>

<script>
import IconHomeSvg from '~/assets/images/svg/icon_home.svg?inline'
import IconTimeSvg from '~/assets/images/svg/icon_time.svg?inline'
import IconUserSvg from '~/assets/images/svg/icon_user.svg?inline'
import IconExhibitionSvg from '~/assets/images/svg/icon_exhibition.svg?inline'
import IconPlaceSvg from '~/assets/images/svg/icon_place.svg?inline'
import IconVideoSvg from '~/assets/images/svg/icon_video.svg?inline'

export default {
  components: {
    IconHomeSvg,
    IconTimeSvg,
    IconUserSvg,
    IconExhibitionSvg,
    IconPlaceSvg,
    IconVideoSvg
  },
  props: {
    current: {
      type: String,
      required: false,
      default: null
    }
  }
}
</script>
<style lang="scss" scoped>
@import '~/assets/css/individual/vgt/2024/vgt2024.scss';
.vgt2024-menu {
  top: 0;
  left: 0;
  background: rgba(#000, 0.9);
  box-shadow: 0 0 30px rgba(#000, 0.7);
  @include media(pc) {
    z-index: 7; //.vgt2024-barより上
    display: flex;
    align-items: center;
    height: 80px;
  }
  @include media(sp) {
    z-index: 10; //一番上
    border-bottom: 1px solid rgba($vgt2024_primary, 0.6);
  }
  &.theme-default {
    position: sticky;
    @include media(pc) {
      margin-bottom: 50px;
      border-radius: 0 0 20px 20px;
    }
    @include media(sp) {
      margin-bottom: 30px;
      margin: 0 -#{$vgt2024_spacer_sp} 30px;
    }
    ul {
      @include media(pc) {
        width: 686px;
        margin-left: auto;
      }
    }
  }
  &.theme-top {
    position: fixed;
    top: 50px;
    @include media(pc) {
      //ブラウザ幅狭い時用の対応
      z-index: 10; //.vgt2024-mainより上
      width: max(60%, 744px);
      margin-left: max(40%, 496px);
      border-radius: 0 0 0 20px;
      .vgt2024-menu-logo {
        display: none;
      }
      ul {
        flex: 1;
      }
    }
    @include media(sp) {
      width: 100%;
    }
  }
  &-logo {
    padding: 0 20px;
    @include media(sp) {
      display: none;
    }
    a {
      display: block;
      &:hover {
        opacity: 0.6;
      }
    }
    img {
      width: 75px;
    }
  }
  ul {
    display: flex;
    @include media(pc) {
      padding-left: 10px;
    }
    li {
      overflow: hidden;
      @include media(pc) {
        flex: auto;
      }
      @include media(sp) {
        flex: 1;
      }
      &.is-current {
        a {
          pointer-events: none;
          color: $vgt2024_primary;
          svg {
            stroke: $vgt2024_primary;
          }
        }
      }
    }
    li + li {
      border-left: 1px solid rgba($vgt2024_primary, 0.4);
    }
    a {
      display: flex;
      justify-content: center;
      align-items: center;
      position: relative;
      text-decoration: none;
      cursor: pointer;
      color: #fff;
      letter-spacing: 1px;
      text-decoration: none;
      @include media(pc) {
        height: 40px;
        font-size: 14px;
      }
      @include media(sp) {
        font-size: min(2.2vw, 12px);
      }
      @include media(pc) {
        &:hover {
          color: $vgt2024_primary;
          svg {
            stroke: $vgt2024_primary;
          }
        }
      }
      strong {
        display: flex;
        align-items: center;
        @include media(sp) {
          justify-content: center;
          flex-direction: column;
          height: 60px;
          padding-bottom: 4px;
          white-space: nowrap;
        }
        svg {
          stroke: #fff;
          stroke-width: 1px;
          fill: none;
          @include media(pc) {
            display: none;
          }
          @include media(sp) {
            display: block;
            width: 28px;
            height: 28px;
            margin-bottom: 5px;
          }
        }
      }
    }
  }
  &-ticket {
    @include media(pc) {
      padding-right: 20px;
    }
    @include media(sp) {
      position: fixed;
      bottom: 10px;
      left: 50%;
      z-index: 10; //一番上
      transform: translateX(-50%);
    }
    a {
      position: relative;
      padding: 2px;
      text-decoration: none;
      overflow: hidden;
      border-radius: 100px;
      filter: brightness(60%);
      @include vgt2024_gradation();
      @include media(pc) {
        &:hover {
          transform: translateY(1px);
          filter: brightness(70%);
        }
      }
      @keyframes shine {
        0% {
          left: -75%;
        }
        90% {
          left: -75%;
        }
        100% {
          left: 125%;
        }
      }
      &::before {
        content: '';
        position: absolute;
        top: 0;
        left: -75%;
        width: 50%;
        height: 95%;
        background: linear-gradient(
          to right,
          rgba(255, 255, 255, 0) 0%,
          rgba(255, 255, 255, 0.3) 100%
        );
        transform: skewX(-25deg);
        // animation: shine 5s infinite linear;
      }
      .inner {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        width: fit-content;
        background: rgba(#000, 0.8);
        border-radius: 100px;
        @include media(pc) {
          height: 50px;
          padding: 0 20px;
        }
        @include media(sp) {
          padding: 12px 50px;
        }
      }
      strong {
        // margin-bottom: 5px;
        font-size: 15px;
        font-weight: bold;
        white-space: nowrap;
        @include vgt2024_gradation($deg: 90deg);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        @include media(sp) {
          font-size: 12px;
        }
      }
      span {
        font-size: 11px;
        white-space: nowrap;
        color: #fff;
        @include media(sp) {
          font-size: 12px;
        }
      }
    }
  }
}
</style>
